/**
 * 用户登陆相关
 */
import api from '@/api'

let login = {}

const doLogin = async function (data) {
    return api.post(`/login`, data)
}
login.doLogin = doLogin

const doRegister = async function (data) {
    return api.post(`/register`, data)
}
login.doRegister = doRegister



export default login
